import {
  DenialDropDownReasons,
  QueryDropDownReasons,
  QueryResolutionDropDownReasons,
} from "../../../../../constants/dropDownReasons";
import { MedicalPaOrdersAuthStatus } from "../../../../../enums/medicalPaOrdersAuthStatus";

export const shouldOpenHoldModal = (newValue: any) => {
  if (newValue === MedicalPaOrdersAuthStatus.Hold) {
    return true;
  }
  return false;
};

export const shouldOpenStatusUpdateModal = (oldValue: any, newValue: any) => {
  // 1. check if new status is Query or Denied by RISA
  if (
    newValue === MedicalPaOrdersAuthStatus.Query ||
    newValue === MedicalPaOrdersAuthStatus.DeniedByRISA
  ) {
    return true;
  }

  if (
    oldValue === MedicalPaOrdersAuthStatus.Query &&
    newValue !== MedicalPaOrdersAuthStatus.Query
  ) {
    return true;
  }

  return false;
};

export const getDropDownOptions = (oldValue: any, newValue: any) => {
  if (newValue === MedicalPaOrdersAuthStatus.Query) {
    return QueryDropDownReasons;
  }
  if (newValue === MedicalPaOrdersAuthStatus.DeniedByRISA) {
    return DenialDropDownReasons;
  }
  if (oldValue === MedicalPaOrdersAuthStatus.Query) {
    return QueryResolutionDropDownReasons;
  }
  return [];
};

export const getDisplayTextForStatusUpdateModal = (newValue: any) => {
  if (newValue === MedicalPaOrdersAuthStatus.Query) {
    return {
      label: "Reason for Query",
      placeholder: "Select the Reason for Query",
    };
  }
  if (newValue === MedicalPaOrdersAuthStatus.DeniedByRISA) {
    return {
      label: "Reason for Denial by RISA",
      placeholder: "Select the Reason for Denial by RISA",
    };
  }
  return {
    label: "Reason for Query Resolution",
    placeholder: "Select the Reason for Query Resolution",
  };
};

export const getCommentTypeForStatusUpdateModal = (newValue: any) => {
  if (newValue === MedicalPaOrdersAuthStatus.Query) {
    return "query";
  }
  if (newValue === MedicalPaOrdersAuthStatus.DeniedByRISA) {
    return "denial";
  }
  return "query_resolution";
};
